<template>
  <div class="mask" v-if="isShowDialog">
    <div class="dialogWrp">
      <div class="contentWrp">
        <div class="logoWrp">
          <img :src="mainProduct.cover.small_cover" class="logo" />
          <div class="price">{{selectedProduct.real_price | priceFilter}}</div>
        </div>

        <div class="titleWrp">
          <div class="title">{{mainProduct.title}}</div>
          <div class="subTitle">{{mainProduct.description}}</div>
          <div class="price">{{mainProduct.related_products[0].zk_final_price | priceFilter}}</div>
        </div>

        <img :src="`${imgUrl}discount.png`" class="discount" />
        <div class="relationWrp">
          <div class="relationItem" v-for="(item, index) in relatedProducts" :key="index" @click="changeSelected(index)" :class="selectedIndex == index ? 'selected' : ''">
            <div class="title">{{item.title}}</div>
            <div class="subTitle">{{item.description}}</div>
            <div class="price">{{item.zk_final_price | priceFilter}}</div>
          </div>
        </div>

        <img :src="`${imgUrl}close.png`" class="close" @click="close"/>
      </div>
      <div class="footWrp">
        <div class="btn" @click="confirm">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  filters: {
    priceFilter(val) {
      return val ? '￥' + (val / 100) : '';
    }
  },
  props: {
    products: {
      type: Array,
      default: () => []
    },
    productId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imgUrl: 'https://sc2.hexiaoxiang.com/h5/purchase/img/',
      isShowDialog: false,
      mainProduct: {},
      relatedProducts: [],
      selectedIndex: null,
      selectedProduct: {},
      payMode: ''
    };
  },
  methods: {
    show() {
      this.isShowDialog = true;
      this.mainProduct = this.products.find((item) => {
        return item.series_number === this.productId;
      });
      const gid = this.mainProduct.related_products[0].gid;

      const tmpProducts = this.products.filter((p, index) => { return p.series_number !== this.productId; });
      this.relatedProducts = tmpProducts.map((item, index) => {
        const other = item.related_products.find((item) => {
          return item.gid !== gid;
        });
        item.zk_final_price = other.zk_final_price;
        return item;
      });
      this.selectedIndex = null;
      this.selectedProduct = this.mainProduct;
    },
    close() {
      this.isShowDialog = false;
    },
    changeSelected(index) {
      this.selectedIndex = (this.selectedIndex !== index) ? index : null;
      if (this.selectedIndex !== null) {
        this.selectedProduct = this.relatedProducts[this.selectedIndex];
      } else {
        this.selectedProduct = this.mainProduct;
      }
    },
    confirm() {
      this.$emit('confirm', this.selectedProduct);
    }
  }
};
</script>
<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 200;
}
.dialogWrp {
  box-sizing: border-box;
  width: 100%;
  background: #ffffff;
  border-radius: 15px 15px 0 0;
  position: absolute;
  bottom: 0;
  padding: 15px;
  display: flex;
  flex-direction: column;

  .contentWrp {
    height: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    .close {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 0;
      right: 0;
    }

    .logoWrp {
      display: flex;
      img {
        width: 80px;
        height: 80px;
        border-radius: 8px;
        margin-right: 10px;
      }
      .price {
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 24px;
        color: #ff6b36;
        text-align: justify;
      }
    }

    .titleWrp {
      margin: 15px 0;
      padding: 18px 15px 18px 10px;
      display: flex;
      height: 58px;
      background: #fffae7;
      border: 1px solid #f8cf00;
      border-radius: 10px;
      box-sizing: border-box;
      position: relative;
      div {
        display: flex;
        align-items: center;
      }

      .title {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 16px;
        color: #3c3531;
      }
      .subTitle {
        margin-left: 4px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #a7a4a1;
        flex-grow: 1;
      }
      .price {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 16px;
        color: #ff6b36;
        text-align: right;
      }
    }

    .discount {
      width: 100%;
    }

    .relationWrp {
      display: flex;
      flex-wrap: wrap;
      padding: 10px;
      box-sizing: border-box;
      background: #f7f7f7;
      border-radius: 0 0 15px 15px;
      width: 100%;
      justify-content: space-between;
      .relationItem:first-child {
        margin-bottom: 9px;
      }

      .relationItem:nth-child(2) {
        margin-bottom: 9px;
      }

      .relationItem {
        width: 48.5%;
        background: #fff;
        display: flex;
        flex-direction: column;
        padding: 16px 10px;
        align-items: center;
        box-sizing: border-box;
        border-radius: 10px;
        .title {
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 15px;
          color: #3c3531;
          overflow:hidden;
          white-space:nowrap;
          text-overflow:ellipsis;
          width:100%;
          text-align: center;
        }
        .subTitle {
          margin-top: 4px;
          margin-bottom: 7px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 12px;
          color: #a7a4a1;
        }
        .price {
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 16px;
          color: #ff6b36;
        }
      }

      .selected {
        background: #FFFAE7;
        border: 1px solid #F8CF00;
      }
    }
  }

  .footWrp {
    padding: 12px 5px 0;
    box-sizing: border-box;
    flex-grow: 0;
    height: 63px;
    .btn {
      height: 51px;
      background: #ffd70a;
      box-shadow: inset 0 -1px 4px 0 #ffc052;
      border-radius: 27.5px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 18px;
      color: #9e531d;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
